import { render, staticRenderFns } from "./FileTypesPopUp.vue?vue&type=template&id=0c982250&"
import script from "./FileTypesPopUp.vue?vue&type=script&lang=js&"
export * from "./FileTypesPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports